import { RoutingType } from '../types';

const initialState: RoutingType = {
    isIframe: false,
    initialPath: undefined,
};

export default initialState;
